import React, { useEffect, useState, useRef } from 'react';
import { Settings, User, ClipboardList, Database, LogOut } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface TopNavProps {
  isVisible: boolean;
  userName?: string;
  onOrdersClick?: () => void;
  onMasterDataClick?: () => void;
  onSettingsClick?: () => void;
  onLogout?: () => void;
}
export function TopNav({
  isVisible,
  userName,
  onOrdersClick,
  onMasterDataClick,
  onSettingsClick,
  onLogout
}: TopNavProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };
    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);
  return <AnimatePresence data-id="element-784">
      {isVisible && <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200" data-id="element-785">
          <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-786">
            <div className="flex justify-center items-center gap-2" data-id="element-787">
              <button onClick={onOrdersClick} className="p-2 text-gray-600 hover:text-blue-600 transition-colors" aria-label="Auftragsübersicht" data-id="element-788">
                <ClipboardList className="w-5 h-5" strokeWidth={1.5} data-id="element-789" />
              </button>
              <button onClick={onMasterDataClick} className="p-2 text-gray-600 hover:text-blue-600 transition-colors" aria-label="Stammdatenverwaltung" data-id="element-790">
                <Database className="w-5 h-5" strokeWidth={1.5} data-id="element-791" />
              </button>
              <button onClick={onSettingsClick} className="p-2 text-gray-600 hover:text-blue-600 transition-colors" aria-label="Einstellungen" data-id="element-792">
                <Settings className="w-5 h-5" strokeWidth={1.5} data-id="element-793" />
              </button>
              <div className="relative" ref={menuRef} data-id="element-794">
                <button onClick={() => setShowUserMenu(!showUserMenu)} className="p-2 text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2" aria-label="Benutzer" data-id="element-795">
                  <User className="w-5 h-5" strokeWidth={1.5} data-id="element-796" />
                  {userName && <span className="text-sm font-medium text-gray-700" data-id="element-797">
                      {userName}
                    </span>}
                </button>
                <AnimatePresence data-id="element-798">
                  {showUserMenu && <motion.div initial={{
                opacity: 0,
                y: -10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} transition={{
                duration: 0.2
              }} className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden" data-id="element-799">
                      <button onClick={() => {
                  setShowUserMenu(false);
                  onLogout?.();
                }} className="w-full flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors text-left" data-id="element-800">
                        <LogOut className="w-4 h-4" strokeWidth={2} data-id="element-801" />
                        <span className="font-medium" data-id="element-802">Abmelden</span>
                      </button>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </motion.nav>}
    </AnimatePresence>;
}